import React from 'react';
import '../../Cards.css';
import CardItem from '../../CardItem';

export default function HobbyHome() {
    
    return ( 
        <div className='cards'>
        <h1>Look through my Hobbies!</h1>
        
        <div className='cards__container'>
            <div className='cards__wrapper'>
            <ul className='cards__items'>
                <CardItem
                src= 'images/img-animation.jpg'
                text='Checkout some animation!'
                label='Animation'
                path='/DigitalPortfolio/hobbies/Animation'
                />
                <CardItem
                src='images/img-programming.jpg'
                text='Find out about my passion for programming!'
                label='Programming'
                path='/DigitalPortfolio/hobbies/Programming'
                />
            </ul>
            <ul className='cards__items'>
                <CardItem
                src='images/img-hobbies.jpg'
                text='I enjoy videogames. Take a look at my console collection!'
                label='Collection'
                path='/DigitalPortfolio/hobbies/Collection'
                />
                <CardItem
                src='images/drawings/img-drawing-anima.jpg'
                text='Explore my drawings!'
                label='Drawing'
                path='/DigitalPortfolio/hobbies/Drawing'
                />
                <CardItem
                src='images/img-repairing.jpg'
                text='Learn about my console and cartridge repair experience!'
                label='Repairing'
                path='/DigitalPortfolio/hobbies/Repairing'
                />
            </ul>
            </div>
        </div>
        </div>
        )
}